export default "__VITE_ASSET__Dq0v2Mj4__"